export default (context = {}) =>
  fieldLibrary = {
    fieldGroups: {
      bulk: {
        _requiredFields: ['name']
        venue:
          name: 'Venue Settings'
          description: ''
          fieldKeys: ['venue_type', 'venue_setting', 'storage_facilities_available']
        advancedFields:
          name: 'Advanced Fields'
          description: ''
          fieldKeys: ['onsite_permissions', 'venue_description', 'occupancy_count', 'storage_capacity', 'images']
        contactOverrides:
          name: 'Contact Overrides'
          description: ''
          fieldKeys: ['contacts']
        audienceExperienceOverrides:
          name: 'Audience Experience Overrides'
          description: ''
          fieldKeys: ['types', 'audience_tags', 'activity_tags', 'demographics']
        calendar:
          name: 'Calendar'
          description: ''
          fieldKeys: ['seasons', 'blockout_dates']
        partnershipExperienceOverrides:
          name: 'Partnership Experience Overrides'
          description: ''
          fieldKeys: ['special_terms', 'sponsor_set', 'preferred_brand_categories', 'sold_out', `/*'cancelation_policy',*/` 'catex']
      }
      advancedSettings: {
        _requiredFields: []
        venue:
          name: 'Venue Settings'
          description: ''
          fieldKeys: ['venue_description', 'onsite_permissions', 'occupancy_count', 'storage_capacity']
        audienceExperience:
          name: 'Audience Experience'
          description: ''
          fieldKeys: ['images', 'host', 'contacts', 'demographics']
        sponsorExperience:
          name: 'Sponsor Experience'
          description: ''
          fieldKeys: ['special_terms', 'preferred_brand_categories', 'sold_out', 'catex']
        calendar:
          name: 'Calendar'
          description: ''
          fieldKeys: ['seasons', 'blockout_dates']
        inventoryCapacity:
          name: 'Inventory Capacity'
          description: ''
          fieldKeys: ['engagement_capacity']
      }
    },
    fields: {
      venue_name: {
        name: 'Venue Name'
        component: 'text'
        inputProps: {
          placeholder: 'Name of this venue'
        }
        options: {
          instructions: 'Enter a recognizable name for this venue'
        }
      }
      venue_type: {
        name: 'Venue Type'
        component: 'select'
        inputProps: {
          placeholder: 'Select type'
        }
        options: {
          instructions: 'Select what kind of establishment this venue is'
          why: 'Some sponsors search for certain kinds of venues'
        }
      }
      venue_setting: {
        name: 'Venue Setting'
        component: 'checkbox-button'
        inputProps: {
          placeholder: 'Select venue setting'
          options: [
            {
              label: 'Indoors'
              value: 'indoors'
              iconClass: 'fas fa-building'
            }
            {
              label: 'Outdoors'
              value: 'outdoors'
              iconClass: 'fas fa-sun'
            }
          ]
        }
        options: {
          instructions: 'Let sponsors know if their audience will be indoors, outdoors or both'
          why: 'Sponsors may have different instructions for indoor vs outdoor spaces'
        }
      }
      storage_facilities_available: {
        name: 'Available Storage'
        component: 'storage'
        options: {
          instructions: 'Select all the storage facilities that will be available to sponsors'
          why: 'Some products shipped to you may need to be kept frozen or refrigerated'
        }
      }
      max_pallet_count: {
        name: 'Max Number of Pallets'
        component: 'number'
        options: {
          instructions: 'How many pallets are you able to receive and store at a time?'
          why: 'Standard pallet measures: 48in Length x 40in Width x 48in Height'
          tips: [
            'Some sponsors may evaluate storage capacity to understand if they can sponsor multiple events and ship all promotional items in a single shipment to save on shipping costs.'
          ]
        }
      }
      physical_signs: {
        name: 'Signage'
        component: 'physical-signs'
        options: {
          required: true
          instructions: 'Let Brands know which signs you can setup at the venue'
          why: 'Not setting up signage may reduce chance of getting a sponsorship'
          alwaysShowWhy: true
        }
      }
      onsite_permissions: {
        name: 'Onsite Permissions'
        component: 'switch'
        inputProps: {
          items: [
            {
              key: 'vehicles_allowed'
              label: 'Vehicles Are Allowed On Site'
              description: 'Vendors are allowed to drive vehicles onto the activation space location (ex: food truck, trailer, branded vehicle as part of set up)'
            }
            {
              key: 'sales_allowed'
              label: 'Selling Products or Services is Allowed'
              description: 'Vendors are allowed to sell items or services (ex: merchandise, food & beverage, subscription plans)'
            }
            {
              key: 'glass_allowed'
              label: 'Glass Bottles or Containers are Allowed'
              description: 'Vendors are allowed to distribute products contained in glass (ex: drinks)'
            }
          ]
        }
        options: {
          instructions: 'Let sponsors if whether or not these items are allowed on the premises'
          why: "It's better to let the sponsor know ahead of time of any onsite restrictions"
        }
      }
      occupancy_count: {
        name: 'Occupancy'
        component: 'text-grid'
        inputProps: {
          cols: 2
          items: [
            {
              key: 'delivery_points'
              label: 'Delivery Points'
              description: '# of delivery points at this venue'
              placeholder: '# of delivery points'
            }
            {
              key: 'delivery_label'
              label: 'Delivery Label'
              description: 'Label for delivery points'
              placeholder: 'Label for delivery points'
            }
            {
              key: 'resident_count'
              label: 'Number of Residences'
              description: '# of people at this venue'
              placeholder: '# of people'
            }
          ]
        }
        options: {
          instructions: 'Number of people who typically are in the venue'
          why: 'Some sponsors want every member to receive 1 sample, some may want to hand out 2 or 3 per person.'
        }
      }
      storage_capacity: {
        name: 'Storage Capacity'
        component: 'text-grid'
        inputProps: {
          cols: 2
          items: [
            {
              key: 'cold_storage_count'
              label: 'Cold Storage Capacity'
              description: 'Sepcified in cubic feet'
              placeholder: '500 cubic feet'
            }
            {
              key: 'frozen_storage_capacity'
              label: 'Frozen Storage Capacity'
              description: 'Sepcified in cubic feet'
              placeholder: '500 cubic feet'
            }
          ]
        }
        options: {
          instructions: 'Specify the size of storage facilities'
          why: 'Helps sponsors know what volume of product they can ship so it adequately fits into the storage available'
        }
      }
      venue_description: {
        name: 'Description'
        component: 'textarea'
        inputProps: {
          placeholder: 'Describe the venue'
        }
        options: {
          instructions: 'Brief description of this venue'
        }
      }
      contacts: {
        name: 'Contact Information'
        component: 'contact-set'
        options: {
          instructions: 'Key people that help make sure everything goes smoothly'
        }
      }
      types: {
        name: 'Additional Types'
        component: 'tags'
        inputProps: {
          placeholder: 'Search...'
          limit: 3
        }
        options: {
          instructions: 'Select additional categories to help describe this experience (up to 3)'
        }
      }
      audience_tags: {
        name: 'Audience Types'
        component: 'tags'
        inputProps: {
          placeholder: 'Search...'
          limit: 3
        }
        options: {
          instructions: 'Tell sponsors about the kind of people who will attending (up to 3)'
        }
      }
      activity_tags: {
        name: 'Activity Tags'
        component: 'tags'
        inputProps: {
          placeholder: 'Search...'
          limit: 3
        }
        options: {
          instructions: 'Add all tags you want.'
          why: 'Why is this important?'
        }
      }
      demographics: {
        name: 'Demographics'
        component: 'demographics'
        options: {
          instructions: 'Let sponsors know an approximate demographic breakdown they will be reaching.'
        }
      }
      sponsor_set: {
        name: 'Brand Partners'
        component: 'brand-select'
        options: {
          instructions: 'List past or current brands you have partnered with so a sponsor is confident that you know how to do this!'
          tips: ["List as many high-quality partners as you can"]
        }
      }
      catex: {
        name: 'Categories'
        component: 'catex-select'
        options: {
          hideName: true
        }
      }
      cancelation_policy: {
        name: 'Cancellation Policy'
        component: 'cancellation-policy'
        options: {
          instructions: 'Set your preferred cancellation policy.'
        }
      }
      special_terms: {
        name: 'Special Terms'
        component: 'textarea'
        inputProps: {
          placeholder: 'Additional terms a sponsor should know about'
        }
        options: {
          instructions: 'Specify specific restriction, additional terms or conditions'
          why: 'Make sure sponsors know about specific considerations or expectation you may have, if any'
        }
      }
      suppliers: {
        name: 'Primary Team'
        component: 'team-select'
        inputProps: {
          placeholder: 'Select a primary team'
        }
        options: {
          instructions: 'Select the team who will primarily manage sponsorships at this venue.'
        }
      }
      venue_location: {
        name: 'In-Person Venue'
        component: 'venue-select'
        options: {
          instructions: ''
        }
      }
      host: {
        name: 'Host'
        component: 'text'
        inputProps: {
          placeholder: 'Name of Host...'
        }
        options: {
          instructions: 'Specify who is hosting this experience'
          why: 'The host may be different than the organization, team or venue'
        }
      }
      preferred_brand_categories: {
        name: 'Preferred Brand Categories'
        component: 'tags'
        inputProps: {
          placeholder: 'Tags'
        }
        options: {
          instructions: 'List any brand categories you feel would be a great fit for the audience'
          why: 'Helps Recess prioritize the sponsors in these categories'
        }
      }
      images: {
        name: 'Photos'
        component: 'media'
        options: {
          instructions: 'Upload pictures showing this venue'
          why: "16:9 aspect size ratio with high resolution shows up best"
          tips: ["acceptable formats are:", "jpg", "png", "gif"]
        }
      }
      sold_out: {
        name: 'Sold Out'
        component: 'switch'
        inputProps: {
          items: [
            {
              key: 'sold_out'
              activeLabel: 'Sold Out'
              inactiveLabel: 'Not Sold Out'
            }
          ]
        }
        options: {
          instructions: 'Let sponsors know if this experience is temporarily sold out or otherwise unavailable'
          why: 'Sold out venues wont be bookable'
        }
      }
      seasons: {
        name: 'Seasonal'
        component: 'seasons'
        options: {
          instructions: 'Setup seasons for when your this venue is available'
          why: 'Events will not be availble in the off-season'
        }
      }
      blockout_dates: {
        name: 'Blockout Dates'
        component: 'blockout-dates'
        options: {
          instructions: 'Specify dates when your audience is not available to engage with sponsorships'
        }
      }
      engagement_capacity: {
        name: 'Inventory Capacity'
        component: 'inventory-capacity'
        options: {
          hideName: true
        }
      }
    }
  }

  library = JSON.parse(JSON.stringify(fieldLibrary))

  for key, field of library.fields
    field.inputProps ||= context.inputProps?[key] || {}
    field.inputProps?.options ||= context.options?[key]
    field.options.required ||= key in (context._requiredFields || [])

  library
